import { AxiosError, AxiosResponse } from 'axios'

import { ApiErrorDTO } from '../dtos/error'

export type ApiResponse<T> = T | ApiErrorDTO

export const unknownError: ApiErrorDTO = {
  errors: [{ title: 'Unknown error', statusCode: 500 }],
}

export async function tryCatch<T>(
  cb: (...args: unknown[]) => Promise<AxiosResponse<T, unknown>>,
): Promise<T | ApiErrorDTO> {
  try {
    return (await cb()).data
  } catch (apiError) {
    console.error('API ERROR:', apiError)

    if (apiError instanceof AxiosError && apiError.name === 'AxiosError') {
      const title: string = apiError.response
        ? (apiError.response.data.message as string) || 'Unknown error'
        : apiError.message
      const statusCode: number = apiError.response?.status || 500
      return { errors: [{ title, statusCode }] }
    }

    // Use type assertion to access properties safely
    const err = apiError as {
      message?: string
      status?: number
      response?: { data?: unknown }
    }
    const error: ApiErrorDTO = {
      errors: [
        {
          title: err.message ?? 'Unknown error',
          statusCode: err.status ?? 500,
        },
      ],
    }
    return error
  }
}

export function hasError(response: unknown): response is ApiErrorDTO {
  return typeof response === 'object' && response !== null && 'errors' in response
}

export const handleError = <ResponseType extends object | ApiErrorDTO>(
  res: ResponseType,
  customError?: ApiErrorDTO,
): ApiErrorDTO => {
  if (customError) return customError
  let error: ApiErrorDTO = unknownError
  if ('errors' in res) {
    error = { errors: res.errors }
  }
  return error
}
